import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { loginRequest } from './msalConfig';

function requiresInteraction(error) {
    return error instanceof InteractionRequiredAuthError ||
        error?.errorCode === "invalid_grant" ||
        error?.errorMessage?.includes("AADSTS700084") ||
        error?.subError === "bad_token";
}

export function acquireAccessToken(instance, accounts) {
    const account = instance.getActiveAccount() ?? accounts?.[0] ?? null;
    const request = {
        ...loginRequest,
    };

    if (account != null) {
        request.account = account;
    }

    return instance.acquireTokenSilent(request)
        .catch(error => {
            if (!requiresInteraction(error)) {
                throw error;
            }

            return instance.acquireTokenPopup(request);
        })
        .then(tokenResponse => {
            if (tokenResponse?.account != null) {
                instance.setActiveAccount(tokenResponse.account);
            }

            return tokenResponse.accessToken;
        });
}
